import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  overflow: "visible",
  preserveAspectRatio: "none",
  style: {"display":"block"},
  viewBox: "0 0 32.323 9.573"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "var(--stroke-0, #C2C2C2)",
  d: "M.19 4.327a.65.65 0 0 0 0 .92l4.137 4.136a.65.65 0 1 0 .92-.92L1.568 4.788 5.246 1.11a.65.65 0 0 0-.919-.92L.19 4.327Zm31.943.92a.65.65 0 0 0 0-.92L27.996.19a.65.65 0 1 0-.92.92l3.678 3.677-3.677 3.677a.65.65 0 1 0 .919.919l4.137-4.137ZM.65 4.786v.65h31.023v-1.3H.65v.65Z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }